import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NumberControl } from '../../../form-models/number-control';

@Component({
  selector: 'hb-dynamic-number',
  templateUrl: './dynamic-number.component.html',
})
export class DynamicNumberComponent {
  @Input() control: NumberControl;
  @Input() formGroup: FormGroup;

  @Output() onOverrideValue = new EventEmitter();

  constructor() {}

  public overrideValue(): void {
    this.onOverrideValue.emit();
  }
}
